// (c) TwistedMinds, Gerry Uytdenhouwen - 5 november 2026

/**
 * The account address that the order form must use, or '' when the e-mail field is not locked.
 * The field is only locked for a logged-in customer that really is loaded and has an address
 * (a leftover token without a customer must leave the field editable), with "Mijn gegevens" on.
 *
 * @param {boolean} isAuth
 * @param {boolean} ordersTableV2  widget.settings.orders_table_v2
 * @param {{email?: string}|null|undefined} customer
 * @returns {string}
 */
export const lockedEmail = (isAuth, ordersTableV2, customer) => {
    if (!isAuth || !ordersTableV2) return '';
    const email = customer && typeof customer.email === 'string' ? customer.email.trim() : '';
    return email;
};

/**
 * E-mail for the order form: the account address while locked, otherwise the proposed one.
 *
 * @param {string} locked  result of lockedEmail()
 * @param {string|null|undefined} proposed
 * @returns {string}
 */
export const emailForForm = (locked, proposed) => locked || proposed || '';
